// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_mlsPlan(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ListOnMlsAsActive",
              "ListOnMlsAsComingSoon",
              "NoMlsPlan"
            ]);
}

var fragmentConverter = {"__root":{"mlsPlan_ListOnMlsAsComingSoon_activeOnMlsOn":{"b":""},"mlsPlan_ListOnMlsAsActive_onMlsAt":{"b":""},"mlsPlan":{"u":"fragment_mlsPlan"},"activeOnMlsSince":{"b":""}}};

var fragmentConverterMap = {
  fragment_mlsPlan: unwrap_fragment_mlsPlan
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyMlsLabel_propertyV5",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "mlsPlan",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "onMlsAt",
                  "storageKey": null
                },
                "action": "THROW"
              }
            ],
            "type": "ListOnMlsAsActive",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activeOnMlsOn",
                  "storageKey": null
                },
                "action": "THROW"
              }
            ],
            "type": "ListOnMlsAsComingSoon",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/)
            ],
            "type": "NoMlsPlan",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeOnMlsSince",
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
};
})());

var wrap_fragment_mlsPlan = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_mlsPlan = unwrap_fragment_mlsPlan;
exports.wrap_fragment_mlsPlan = wrap_fragment_mlsPlan;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
